import React, { useState } from 'react'
import { Grid } from '@scuf/common'
import Line from '../../components/charts/Line/Line'
import KPIStat from '../../components/common/KPIStat/KPIStat'
//import TitlePage from '../../components/TitlePage/TitlePage'


const Procesos = () => {

    // const refresh = () => {
    //     window.location.reload();
    // }
    /*
    const [value, setValue] = useState();
    const refresh = () => {
        setValue({});
    }
    setTimeout(() => {
        refresh()
    }, 1000 * 60 * 60 * 2);
    */

    return (
        <>
            <Grid className='m-0 p-0' >
                <Grid.Row>
                    {/* <TitlePage title='' /> */}
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column xsWidth='12' sWidth='2' mWidth='2' lWidth='2' xlWidth='2'>
                        <div style={{ padding: '0px' }}>
                            <KPIStat
                                url='sp_GetData'
                                body={{ params: '010101' }}
                                isCard='1'
                                titleCard='GLOBAL'
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column xsWidth='12' sWidth='2' mWidth='2' lWidth='2' xlWidth='2'>
                        <div style={{ padding: '0px' }}>
                            <KPIStat
                                url='sp_GetData'
                                body={{ params: '010102' }}
                                isCard='1'
                                titleCard='CHUQUICAMATA'
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column xsWidth='12' sWidth='2' mWidth='2' lWidth='2' xlWidth='2'>
                        <div style={{ padding: '0px' }}>
                            <KPIStat
                                url='sp_GetData'
                                body={{ params: '010103' }}
                                isCard='1'
                                titleCard='MINISTRO HALES'
                            />
                        </div>
                    </Grid.Column>

                    <Grid.Column xsWidth='12' sWidth='2' mWidth='2' lWidth='2' xlWidth='2'>
                        <div style={{ padding: '0px' }}>
                            <KPIStat
                                url='sp_GetData'
                                body={{ params: '010104' }}
                                isCard='1'
                                titleCard='SALVADOR'
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column xsWidth='12' sWidth='2' mWidth='2' lWidth='2' xlWidth='2'>
                        <div style={{ padding: '0px' }}>
                            <KPIStat
                                url='sp_GetData'
                                body={{ params: '010105' }}
                                isCard='1'
                                titleCard='ANDINA'
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column xsWidth='12' sWidth='2' mWidth='2' lWidth='2' xlWidth='2'>
                        <div style={{ padding: '0px' }}>
                            <KPIStat
                                url='sp_GetData'
                                body={{ params: '010106' }}
                                isCard='1'
                                titleCard='EL TENIENTE'
                            />
                        </div>
                    </Grid.Column>
                </Grid.Row>


                <Grid.Row >
                    <Grid.Column xsWidth='12' sWidth='6' mWidth='6' lWidth='6' xlWidth='6'>
                        <div style={{ padding: '0px' }}>
                            <Line
                                url='sp_GetData'
                                body={{ params: '010201' }}
                                //body=''
                                isCard='0'
                                yAxisTitle='TON/HR'
                                titleCard='CHUQUICAMATA'
                                randomSeries={['A', 'B', 'C', 'D']}
                            />

                        </div>

                    </Grid.Column>
                    <Grid.Column xsWidth='12' sWidth='6' mWidth='6' lWidth='6' xlWidth='6'>
                        <div style={{ padding: '0px' }}>
                            <Line
                                url='sp_GetData'
                                body={{ params: '010202' }}
                                // body=''
                                isCard='0'
                                yAxisTitle='TPH'
                                titleCard='CHUQUICAMATA - ULTIMAS 24 HORAS'
                                randomSeries=''
                            />
                        </div>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column xsWidth='12' sWidth='6' mWidth='6' lWidth='6' xlWidth='6'>
                        <div style={{ padding: '0px' }}>
                            <Line
                                url='sp_GetData'
                                body={{ params: '010301' }}
                                isCard='0'
                                yAxisTitle='TON/HR'
                                titleCard='MINISTRO HALES'
                                randomSeries=''
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column xsWidth='12' sWidth='6' mWidth='6' lWidth='6' xlWidth='6'>
                        <div style={{ padding: '0px' }}>
                            <Line
                                url='sp_GetData'
                                body={{ params: '010302' }}
                                isCard='0'
                                yAxisTitle='TPH'
                                titleCard='MINISTRO HALES - ULTIMAS 24 HORAS'
                                randomSeries=''
                            />
                        </div>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column xsWidth='12' sWidth='6' mWidth='6' lWidth='6' xlWidth='6'>
                        <div style={{ padding: '0px' }}>
                            <Line
                                url='sp_GetData'
                                body={{ params: '010401' }}
                                isCard='0'
                                yAxisTitle='TON/HR'
                                titleCard='SALVADOR'
                                randomSeries=''
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column xsWidth='12' sWidth='6' mWidth='6' lWidth='6' xlWidth='6'>
                        <div style={{ padding: '0px' }}>
                            <Line
                                url='sp_GetData'
                                body={{ params: '010402' }}
                                isCard='0'
                                yAxisTitle='TPH'
                                titleCard='SALVADOR - ULTIMAS 24 HORAS'
                                randomSeries=''
                            />
                        </div>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column xsWidth='12' sWidth='6' mWidth='6' lWidth='6' xlWidth='6'>
                        <div style={{ padding: '0px' }}>
                            <Line
                                url='sp_GetData'
                                body={{ params: '010501' }}
                                isCard='0'
                                yAxisTitle='TON/HR'
                                titleCard='ANDINA'
                                randomSeries=''
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column xsWidth='12' sWidth='6' mWidth='6' lWidth='6' xlWidth='6'>
                        <div style={{ padding: '0px' }}>
                            <Line
                                url='sp_GetData'
                                body={{ params: '010502' }}
                                isCard='0'
                                yAxisTitle='TPH'
                                titleCard='ANDINA - ULTIMAS 24 HORAS'
                                randomSeries=''
                            />
                        </div>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column xsWidth='12' sWidth='6' mWidth='6' lWidth='6' xlWidth='6'>
                        <div style={{ padding: '0px' }}>
                            <Line
                                url='sp_GetData'
                                body={{ params: '010601' }}
                                isCard='0'
                                yAxisTitle='TON/HR'
                                titleCard='EL TENIENTE'
                                randomSeries=''
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column xsWidth='12' sWidth='6' mWidth='6' lWidth='6' xlWidth='6'>
                        <div style={{ padding: '0px' }}>
                            <Line
                                url='sp_GetData'
                                body={{ params: '010602' }}
                                isCard='0'
                                yAxisTitle='TPH'
                                titleCard='EL TENIENTE - ULTIMAS 24 HORAS'
                                randomSeries={''}
                            />
                        </div>
                    </Grid.Column>
                </Grid.Row>



            </Grid>
        </>
    )
}

export default Procesos
